import React from 'react';
import { isEmpty } from 'lodash';
import { Modal, Row, Col, Button, Form, Spinner } from 'react-bootstrap';
import { isMobileOnly } from 'react-device-detect';
import { DropdownList } from 'react-widgets';

import {
  RenderErrorUI,
  RenderUploadedFile
} from '../../../Education/EducationModals/AddEditUpload/CommonUploadComponent';
import BGVCamera from '../../../../../CommonComponent/BGVCamera';
import ImagePreviewModal from '../../../../../CommonComponent/ImagePreviewModal';
import Image from '../../../../../../../core-components/Image';
import AppConstants from '../../../../../../../core-components/AppConstants';

import styles from './FilesStep.module.scss';
import PasswordProtectedModal from '../../../PasswordProtectedModal';
import {
  FileErrorMeaage,
  getFileHeader,
  validateImage
} from '../../../../../../../utils/utilities';
import { pdfjs } from 'react-pdf';

class FilesStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doc_upload: {
        proof_doc: []
      },
      imagePreviewUrl: '',
      showImagePreviewModal: false,
      takePhoto: false,
      isCamHavingError: false,
      showPasswordProtectedModal: false
    };
  }

  modalHide = () => {
    this.setState({
      showPasswordProtectedModal: false
    });
    let docCopy = [...this?.state?.doc_upload?.proof_doc];
    docCopy.splice(this.props.uploadedSingleGradesheet.index, 1);
    this.setState({
      doc_upload: { ...this.state.doc_upload, proof_doc: [...docCopy] },
      takePhoto: false,
      isCamHavingError: false
    });
  };

  submitHandlerPasswordModal = (password = '') => {
    //Function for handling submit password when unable to unlock the file and when successfully saved the password
    this.setState({
      showPasswordProtectedModal: false
    });
    let docCopy = [...this?.state?.doc_upload?.proof_doc];
    docCopy[this.props.uploadedSingleGradesheet.index]['link'] =
      this.props.uploadedSingleGradesheet.link.data;
    docCopy[this.props.uploadedSingleGradesheet.index]['isPdf'] = true;
    docCopy[this.props.uploadedSingleGradesheet.index]['loading'] = false;
    docCopy[this.props.uploadedSingleGradesheet.index]['password'] = password;

    this.setState({
      doc_upload: { ...this.state.doc_upload, proof_doc: [...docCopy] },
      takePhoto: false,
      isCamHavingError: false
    });
    this.props.updateGradeSheetWithPasswordAction(docCopy);
  };

  handleFileUpload = (formData, isPdf, index, setCameraSubmitting = null, file) => {
    var that = this;

    let empdocCopy = [...that.state.doc_upload.proof_doc];
    empdocCopy[index] = { link: '', error: '', loading: true, isPdf: isPdf };

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function () {
      if (reader.result) {
        that.setState(
          {
            doc_upload: { ...that.state.doc_upload, proof_doc: [...empdocCopy] }
          },
          () => {
            that.props
              .educationGradesheetUpload({ formData, isPdf: isPdf, index })
              .then(() => {
                try {
                  if (isPdf) {
                    const loadingTask = pdfjs.getDocument({
                      data: reader.result,
                      password: ''
                    });
                    loadingTask.promise
                      .then((pdfDocument) => {
                        let docCopy = [...that?.state?.doc_upload?.proof_doc];

                        docCopy[index] = {
                          link: that?.props?.uploadedGradesheet?.length
                            ? that?.props?.uploadedGradesheet[index]?.link
                            : '',
                          error: '',
                          loading: false,
                          isPdf: that?.props?.uploadedGradesheet?.length
                            ? that?.props?.uploadedGradesheet[index]?.isPdf
                            : false
                        };
                        if (setCameraSubmitting && isMobileOnly) {
                          setCameraSubmitting(false);
                        }

                        that.setState({
                          doc_upload: { ...that.state.doc_upload, proof_doc: [...docCopy] },
                          takePhoto: false,
                          isCamHavingError: false
                        });
                      })
                      .catch((error) => {
                        if (error.message == 'No password given') {
                          that.setState({
                            showPasswordProtectedModal: true
                          });
                        }
                      });
                  } else {
                    let docCopy = [...that?.state?.doc_upload?.proof_doc];

                    docCopy[index] = {
                      link: that?.props?.uploadedGradesheet?.length
                        ? that?.props?.uploadedGradesheet[index]?.link
                        : '',
                      error: '',
                      loading: false,
                      isPdf: that?.props?.uploadedGradesheet?.length
                        ? that?.props?.uploadedGradesheet[index]?.isPdf
                        : false
                    };
                    if (setCameraSubmitting && isMobileOnly) {
                      setCameraSubmitting(false);
                    }

                    that.setState({
                      doc_upload: { ...that.state.doc_upload, proof_doc: [...docCopy] },
                      takePhoto: false,
                      isCamHavingError: false
                    });
                  }
                } catch (e) {
                  console.log(e);
                }
              })
              .catch((error) => {
                console.error(error);
                let docCopy = [...that.state.doc_upload.proof_doc];
                docCopy[index] = {
                  link: '',
                  error: 'Upload failed. File format not valid.',
                  loading: false,
                  isPdf: isPdf,
                  password: ''
                };

                if (setCameraSubmitting && isMobileOnly) {
                  setCameraSubmitting(false);
                }
                that.setState({
                  doc_upload: { ...that.state.doc_upload, proof_doc: [...docCopy] },
                  isCamHavingError: false
                });
              });
          }
        );
      }
    };
  };

  handleFileSelect = (e, type, index) => {
    let fileType = '';
    var blob = e.target.files[0];
    var fileReader = new FileReader();
    fileReader.onloadend = () => {
      var arr = new Uint8Array(fileReader.result).subarray(0, 4);
      var header = '';
      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }
      // Check the file signature against known types
      fileType = getFileHeader(header);
      const errMessage = validateImage(blob, fileType);
      const isPdf = fileType === 'application/pdf' ? true : false;
      if (!errMessage) {
        let formData = new FormData();
        formData.append(`file`, blob);
        formData.append(`file_type`, 'CHECK_DOCUMENT');
        this.handleFileUpload(formData, isPdf, index, null, blob);
      } else {
        let empdocCopy = [...this.state.doc_upload.proof_doc];
        empdocCopy[index] = {
          link: '',
          error: FileErrorMeaage[errMessage],
          loading: false,
          isPdf: isPdf
        };
        this.setState({
          doc_upload: { ...this.state.doc_upload, proof_doc: [...empdocCopy] }
        });
      }
    };

    if (blob instanceof Blob) {
      {
        /** To avoid TyperError issue reported by sentry, need to check if param is an Blob type or not */
      }
      fileReader.readAsArrayBuffer(blob);
    } else {
      console.error(
        `Failed to execute 'readAsArrayBuffer' on 'FileReader': parameter is not of type 'Blob'`
      );
    }
  };

  //for clearing error.
  clearError = (type, index) => {
    const empdocCopy = [...this.state.doc_upload.proof_doc];
    // empdocCopy[index] = { link: '', error: '', loading: false, isPdf: false };
    empdocCopy.splice(index, 1);
    this.setState({ doc_upload: { ...this.state.doc_upload, proof_doc: [...empdocCopy] } });
  };

  //for checking any of the image uploaded is not having link, error, loading
  isImageHavingError = () => {
    let isImageHavingError = false;
    for (let value of this.state.doc_upload.proof_doc) {
      if (!value.link || value.error || value.loading) {
        isImageHavingError = true;
        break;
      }
    }
    return isImageHavingError;
  };

  //handling preview of image
  handleImagePreview = (url) => {
    this.setState({
      imagePreviewUrl: url || '',
      showImagePreviewModal: !this.state.showImagePreviewModal
    });
  };

  //handling delete of image
  handleDeleteImage = (type, index) => {
    const empdocCopy = [...this.state.doc_upload.proof_doc];
    empdocCopy.splice(index, 1);
    this.setState({ doc_upload: { ...this.state.doc_upload, proof_doc: [...empdocCopy] } }, () => {
      this.props.deleteGradesheetUpload(empdocCopy);
    });
  };

  handleCamPhoto = () => {
    this.setState({
      takePhoto: !this.state.takePhoto,
      isCamHavingError: false
    });
  };

  isSaveButtonEnable = () => {
    if (!this.isImageHavingError() && !isEmpty(this.props.values.doc_type)) {
      return true;
    }
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    let cloneDocs = [];

    for (let value of this.state.doc_upload.proof_doc) {
      if (value.link) {
        cloneDocs.push({ link: value.link, isPdf: value.isPdf, password: value.password });
      }
    }
    this.props.setFieldValue('proof_doc', cloneDocs);
    this.props.handleSubmit();
  };

  enablePhotoBtn = () => {
    let isImageHavingError = false;

    if (isMobileOnly) {
      for (let value of this.state.doc_upload.proof_doc) {
        if (value.error) {
          isImageHavingError = true;
          break;
        }
      }
    }
    return isImageHavingError;
  };

  componentDidMount() {
    const doc_upload_copy = Object.assign({}, { ...this.state.doc_upload });
    let documents = this.props.values.proof_doc;

    if (this.props.empDocType) {
      this.props.setFieldValue('doc_type', this.props.empDocType);
    }
    if (this.props?.uploadedGradesheet?.length > 0) {
      doc_upload_copy.proof_doc = this.props.uploadedGradesheet.map((item) => {
        return {
          link: item?.link,
          error: '',
          loading: false,
          isPdf: item?.isPdf || item?.is_pdf,
          password: item.password
        };
      });
    } else if (documents.length > 0) {
      doc_upload_copy.proof_doc = documents.map((item) => {
        return {
          link: item?.link,
          error: '',
          loading: false,
          isPdf: item?.isPdf || item?.is_pdf,
          password: item?.password
        };
      });
    } else {
      doc_upload_copy['proof_doc'].push({
        link: '',
        error: '',
        loading: false,
        isPdf: false,
        password: ''
      });
    }

    this.setState({
      doc_upload: { ...doc_upload_copy }
    });
  }

  render() {
    const { isSubmitting, values, setFieldValue } = this.props;
    const isValidForm =
      this.state.doc_upload.proof_doc.length > 0 &&
      !this.isImageHavingError() &&
      !isEmpty(values.doc_type);

    const enableTakePhotoBtn = this.enablePhotoBtn() && this.state.doc_upload.proof_doc.length < 10;

    const renderEmpDocHavingLength = () => {
      return this.state.doc_upload.proof_doc.map((item, index) => {
        return item.error ? (
          <Col
            lg={5}
            md={5}
            sm={11}
            xs={11}
            key={`emp_doc${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <RenderErrorUI
              handleClick={this.clearError}
              errorText={item.error}
              index={index}
              type='empdoc'
            />
          </Col>
        ) : item.loading ? (
          <Col
            lg={5}
            md={5}
            sm={11}
            xs={11}
            key={`emp_doc${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <div className={styles.certificateInputFileContainer}>
              <Spinner animation='border' variant='primary' />
            </div>
          </Col>
        ) : item.link ? (
          <Col
            lg={5}
            md={5}
            sm={10}
            xs={10}
            key={`emp_doc${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <RenderUploadedFile
              item={item}
              handleImagePreview={this.handleImagePreview}
              handleDeleteImage={this.handleDeleteImage}
              type='empdoc'
              index={index}
              isPdf={item.isPdf}
            />
          </Col>
        ) : (
          <Col
            lg={5}
            md={5}
            sm={11}
            xs={11}
            key={`emp_doc${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <label className={styles.certificateInputFileContainer}>
              <div>
                <Image name='certificate_upload_enable.png' />
                <p>Add your employment proof</p>
                <Form.Control
                  id='formControlsFile'
                  accept='image/*,application/pdf'
                  type='file'
                  label='File'
                  onChange={(e) => this.handleFileSelect(e, 'empdoc', index)}
                />
              </div>
            </label>
          </Col>
        );
      });
    };

    const renderUploadEmpDoc = () => {
      return (
        <Col lg={5} md={5} sm={11} xs={11}>
          <label className={styles.certificateInputFileContainer}>
            <div>
              <Image name='certificate_upload_enable.png' />
              <p>Add your employment proof</p>
              <Form.Control
                id='formControlsFile'
                accept='image/*,application/pdf'
                type='file'
                label='File'
                onChange={(e) =>
                  this.handleFileSelect(e, 'empdoc', this.state.doc_upload.proof_doc.length)
                }
              />
            </div>
          </label>
        </Col>
      );
    };
    const dropdownArray = [
      { label: 'Relieving Letter', value: 'RelievingLetter' },
      { label: 'Last 3 months payslips', value: 'SalarySlip' },
      { label: 'Experience Letter', value: 'ExperienceLetter' }
    ];
    return (
      <>
        <Modal
          size={this.state.showPasswordProtectedModal ? 'sm' : 'lg'}
          show={this.props.show}
          onHide={this.props.onHide}
          dialogClassName='empFilesModal'
          backdrop='static'
          aria-labelledby='contained-modal-title-vcenter'
          backdropClassName={'customBGVModalBackdrop'}
        >
          <div style={this.state.showPasswordProtectedModal ? { display: 'none' } : null}>
            <Modal.Header closeButton>
              <Modal.Title id='contained-modal-title-vcenter'>
                <div className={styles.employmentModalTitle}>
                  <span>Add Employment</span>
                </div>
                <div className={styles.employmentModalSubTitle}>
                  <span>{`Step 2 of 3`}</span>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Form onSubmit={this.handleFormSubmit}>
              {/* {!this.state.showPasswordProtectedModal ? ( */}
              <Modal.Body className={styles.addEditEducationModalBody}>
                <Row className={styles.employmentProofContainer}>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <p className={styles.employmentProofTitle}>Add your Employment proof</p>
                    <p className={styles.employmentProofDescription}>
                      {
                        'Please upload either your relieving letter, salary slip or your experience certificate as proof. Upload .png, .jpg, .jpeg or pdf file only'
                      }
                    </p>
                  </Col>
                </Row>
                <Form.Label>
                  Select document type<span>*</span>
                </Form.Label>
                <Row>
                  <Col sm={12} xs={12} md={6} lg={6} className={styles.customDropdown}>
                    <DropdownList
                      data={dropdownArray}
                      textField='label'
                      value={
                        dropdownArray.filter((object) => object.value === values.doc_type)[0] ||
                        null
                      }
                      selectIcon={<Image name='dropdownArrow.svg' />}
                      onChange={(value) => {
                        setFieldValue('doc_type', value.value);
                        this.props.setEmpDocType(value.value); //setting doc type in redux store
                      }}
                    />
                  </Col>
                </Row>
                {values.doc_type !== null && (
                  <Row className={styles.degreeCertificateContainer}>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <p className={styles.degreeCertificateTitle}>
                        Add your employment proof <span>*</span>
                      </p>
                    </Col>
                    {isMobileOnly ? (
                      <Col sm={12} xs={12}>
                        <Row>
                          <Col sm={11} xs={11} className={styles.takePhotoBtnContainer}>
                            <Button
                              className={styles.takePhotoBtn}
                              onClick={() => this.handleCamPhoto()}
                              disabled={enableTakePhotoBtn}
                            >
                              Take Photo of proof
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    ) : null}

                    <Col lg={10} md={10} sm={12} xs={12}>
                      <Row
                        style={isMobileOnly ? { display: 'flex', justifyContent: 'center' } : null}
                      >
                        <>
                          {this.state.doc_upload.proof_doc.length
                            ? renderEmpDocHavingLength()
                            : null}
                          {this.state.doc_upload.proof_doc.length < 10 && !this.isImageHavingError()
                            ? renderUploadEmpDoc()
                            : null}
                        </>
                      </Row>
                    </Col>
                  </Row>
                )}
                {this.state.showImagePreviewModal && (
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <ImagePreviewModal
                        showImagePreviewModal={this.state.showImagePreviewModal}
                        handleImagePreview={this.handleImagePreview}
                        imagePreviewUrl={this.state.imagePreviewUrl}
                      />
                    </Col>
                  </Row>
                )}
                {isMobileOnly && this.state.takePhoto && (
                  <BGVCamera
                    type='multiple'
                    showBgvCameraModal={this.state.takePhoto}
                    handleCameraModal={this.handleCamPhoto}
                    handleMultipleUpload={this.handleFileUpload}
                    isCameraUploadError={this.state.isCamHavingError}
                    index={
                      this.state.doc_upload.proof_doc.length && !this.isImageHavingError()
                        ? this.state.doc_upload.proof_doc.length
                        : this.state.doc_upload.proof_doc.length && this.isImageHavingError()
                        ? this.state.doc_upload.proof_doc.length - 1
                        : this.state.doc_upload.proof_doc.length
                    }
                  />
                )}
              </Modal.Body>
              {/* ) : null} */}
              <Modal.Footer className={styles.employmentSubmitBtn}>
                <Col sm={6} xs={6} md={3} lg={3}>
                  <Button
                    className={styles.cancelBtn}
                    onClick={(e) => {
                      this.props.subPrevStep();
                    }}
                  >
                    Go Back
                  </Button>
                </Col>
                <Col sm={6} xs={6} md={3} lg={3}>
                  <Button
                    type='submit'
                    className={!isValidForm || isSubmitting ? styles.disabledBtn : styles.activeBtn}
                    disabled={isSubmitting || !isValidForm}
                  >
                    Next
                  </Button>
                </Col>
              </Modal.Footer>
            </Form>
          </div>
        </Modal>
        {this.state.showPasswordProtectedModal && (
          <PasswordProtectedModal
            submitHandler={this.submitHandlerPasswordModal}
            subShow={this.state.showPasswordProtectedModal}
            checkType={'employment'}
            SubOnHide={this.modalHide}
          />
        )}
      </>
    );
  }
}

export default FilesStep;
